// extracted by mini-css-extract-plugin
module.exports = {"root":"secondary_root__tZ8IK"};